import request from '@/utils/request'

/**
 * 登录接口
 * @data {*} data
 */
export function login(data) {
  return request({
    url: '/apiv2/aiClassroom/user/teacherLogin',
    method: 'post',
    data
  })
}

/**
 * 退出登录
 * @data {*} data
 */
export function logout(data) {
  return request({
    url: '/apiv2/aiClassroom/user/logout',
    method: 'post',
    data
  })
}

/**
 * 教师通过原密码去修改密码
 * @data {*} data
 */
export function updatePwd(data) {
  return request({
    url: '/apiv2/aiClassroom/user/updatePwd',
    method: 'post',
    data
  })
}

/**
 * 获取二维码接口
 * @data {*} data
 */
export function generateAiClassroomQrCode(data) {
  return request(
    {
      url: '/apiv2/aiClassroom/qrCode/generateAiClassroomQrCode',
      method: 'post',
      data
    },
    'aiClassroom',
    'no-prompt'
  )
}

/**
 * 查询二维码扫码状态
 * @data {*} data
 */
export function getStatus(data) {
  return request(
    {
      url: '/apiv2/aiClassroom/qrCode/getStatus',
      method: 'post',
      data
    },
    'aiClassroom',
    'no-prompt'
  )
}

/**
 * 使用教师端token登录AI听说课堂
 * @data {*} data
 */
export function thirdPartyLogin(data) {
  return request({
    url: '/apiv2/aiClassroom/user/thirdPartyLogin',
    method: 'post',
    data
  })
}
